import { useTypewriter } from '@/shared/hooks/useTypewriter'
import { useEffect, useState } from 'react'

interface Options {
  value: string | undefined
  placeholder: string
  animationEnabled?: boolean
}

interface Result {
  placeholder: string
  onFocus: () => void
  onBlur: () => void
}

export function useAnimatedPlaceholder({
  value,
  placeholder: placeholderText,
  animationEnabled = true,
}: Options): Result {
  const [isFocused, setIsFocused] = useState(false)
  const [idleReady, setIdleReady] = useState(false)

  const isEmpty = !value
  const shouldAnimate =
    isEmpty && !isFocused && animationEnabled && placeholderText.length > 0

  useEffect(() => {
    if (!shouldAnimate) {
      setIdleReady(false)
      return
    }
    setIdleReady(true)
  }, [shouldAnimate])

  const animated = useTypewriter(placeholderText, {
    enabled: shouldAnimate && idleReady,
    speed: 28,
    startDelay: 0,
    loop: false,
  })

  const placeholder = isFocused
    ? ''
    : shouldAnimate
      ? idleReady
        ? animated
        : ''
      : placeholderText

  const onFocus = () => {
    setIsFocused(true)
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  return { placeholder, onFocus, onBlur }
}
